import React from 'react';

type Props = {
  className?: string;
  title?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
  tabIndex?: 0 | -1;
  ref?: React.Ref<SVGElement>
};

const GridViewInner = ({
  className,
  title,
  ariaHidden,
  ariaLabel,
  tabIndex,
}: Props) => {
  return (
    <svg
      className={className}
      aria-hidden={ariaHidden}
      role={ariaHidden ? undefined : "img"}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      xmlSpace="preserve"
    >
      { title && <title>{ title }</title> }
      <path d="M0,0h24v2H0V0z M22,24V0h2v24H22z M0,24V0h2v24H0z M0,22h24v2H0V22z M10.5,10.5h3v3h-3V10.5z M10.5,4.5h3v3h-3V4.5z M10.5,16.5h3v3h-3V16.5z M16.5,10.5h3v3h-3V10.5z M16.5,4.5h3v3h-3V4.5z M16.5,16.5l3,0l0,3l-3,0L16.5,16.5z M4.5,10.5h3v3h-3V10.5z M4.5,4.5h3v3h-3V4.5z M4.5,16.5h3v3h-3V16.5z"/>
      {/* thick */}
      {/* <path d="M0,0h24v2H0V0z M22,24V0h2v24H22z M0,24V0h2v24H0z M0,22h24v2H0V22z M10,10h4v4h-4V10z M10,4h4v4h-4V4z M10,16h4v4h-4V16z M16,10h4v4h-4V10z M16,4h4v4h-4V4z M16,16.1l4-0.1v3.9L16,20V16.1z M4,10h4v4H4V10z M4,4h4v4H4V4z M4,16h4v4H4V16z"/> */}
    </svg>
  )
};

export const GridView = React.forwardRef<SVGElement, Props>((props, forwardRef) => <GridViewInner {...props} ref={forwardRef} />);
